import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class RegistrationService {
  env: any = environment;

  constructor(private http: HttpClient) {}

  register(user) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/actions/register",
          {
            email: user.email,
            password: user.password,
            firstName: user.firstName,
            lastName: user.lastName,
            invitationToken: user.invitationToken,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          console.log("Success: User registered!");
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  resendLink(email) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/actions/resend",
          {
            email: email,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          console.log("Success: User registered!");
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/registration/registration.service.ts